import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Elevation from '@segment/matcha/components/Elevation'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import { SignupButtonText } from '@segment/matcha/recipes/SignupButton'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `For Engineering and Data Teams`,
  heading: `The ultimate data pipeline`,
  description: `Segment is the single platform to collect and manage your data.`,
  linkText: `Create a free account`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const afterContent = (
    <SignupButtonText size="medium">
      {copy.linkText}
      <ChevronRightIcon />
    </SignupButtonText>
  )

  return (
    <Wrapper>
      <HeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Overline tag="h5" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier="site-engineering-demo"
              successMessageAppearance="twilioLight"
              after={afterContent}
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <Elevation elevation={6}>
            <picture>
              <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
              <HeroRecipe.Image width="648" height="456" src={heroPng2x} alt="" loading="lazy" />
            </picture>
          </Elevation>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
